import { render, staticRenderFns } from "./DetailsFormPage.vue?vue&type=template&id=2dc7ad1a&"
import script from "./DetailsFormPage.vue?vue&type=script&lang=js&"
export * from "./DetailsFormPage.vue?vue&type=script&lang=js&"
import style0 from "./DetailsFormPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports